<template>
    <div>
        <NavbarOne/>

        <div class="flex items-center gap-4 flex-wrap bg-overlay p-14 sm:p-16 before:bg-title before:bg-opacity-70" :style="{backgroundImage:'url(' +  bg  + ')'}">
            <div class="text-center w-full">
                <h2 class="text-white text-8 md:text-[40px] font-normal leading-none text-center">Order History</h2>
                <ul class="flex items-center justify-center gap-[10px] text-base md:text-lg leading-none font-normal text-white mt-3 md:mt-4">
                    <li><router-link to="/index-v2">Home</router-link></li>
                    <li>/</li>
                    <li class="text-primary">History</li>
                </ul>
            </div>
        </div>

        <div class="s-py-100" data-aos="fade-up">
            <div class="container-fluid">
                <div class="max-w-[1720px] mx-auto flex items-start gap-8 md:gap-12 2xl:gap-24 flex-col md:flex-row my-profile-navtab">
                    <div class="w-full md:w-[200px] lg:w-[300px] flex-none">
                        <ProfileTab/>
                    </div>
                    <div class="w-full md:w-auto md:flex-1 overflow-auto">
                        <div class="bg-[#F8F8F9] dark:bg-dark-secondary p-5 sm:p-8 lg:p-[50px] order-history-table">
                            <div v-if="!loading && orders.length" class="grid gap-6">
                                <div
                                    v-for="order in orders"
                                    :key="order.id"
                                    class="rounded-2xl border border-[#17243026] border-opacity-15 bg-white dark:bg-title/10 p-5 sm:p-6"
                                >
                                    <div class="flex items-start justify-between gap-4 flex-col lg:flex-row">
                                        <div class="grid gap-2">
                                            <div class="flex items-center gap-3 flex-wrap">
                                                <h4 class="text-lg md:text-xl font-semibold leading-none text-title dark:text-white">
                                                    {{ order.number }}
                                                </h4>
                                                <span :class="statusBadgeClass(order.status)" class="py-[7px] px-[10px] font-semibold leading-none text-white text-sm rounded inline-flex">
                                                    {{ order.status_label || order.status }}
                                                </span>
                                            </div>
                                            <p class="text-sm md:text-base text-paragraph dark:text-white-light">
                                                {{ formatOrderDate(order.ordered_at) }}
                                            </p>
                                            <p class="text-sm md:text-base text-paragraph dark:text-white-light">
                                                {{ formatShippingAddress(order) }}
                                            </p>
                                        </div>

                                        <div class="flex items-start sm:items-center gap-3 flex-col sm:flex-row">
                                            <div class="text-left sm:text-right">
                                                <p class="text-sm text-paragraph dark:text-white-light">Total</p>
                                                <p class="text-lg md:text-xl font-semibold leading-none text-title dark:text-white">
                                                    {{ formatPrice(order.total, order.currency) }}
                                                </p>
                                            </div>
                                            <a
                                                v-if="order.invoice_url"
                                                :href="order.invoice_url"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                class="btn btn-outline"
                                                data-text="Download Invoice"
                                            >
                                                <span>Download invoice</span>
                                            </a>
                                            <button
                                                type="button"
                                                class="btn btn-theme-solid"
                                                data-text="Reorder"
                                                :disabled="reorderingOrderId === order.id"
                                                @click="reorder(order)"
                                            >
                                                <span>{{ reorderingOrderId === order.id ? 'Reordering...' : 'Reorder' }}</span>
                                            </button>
                                        </div>
                                    </div>

                                    <ul class="mt-6 border-t border-bdr-clr dark:border-bdr-clr-drk">
                                        <li class="title hidden sm:flex items-center justify-between gap-5 py-4 border-b border-bdr-clr dark:border-bdr-clr-drk">
                                            <span class="cart-product-title text-lg font-semibold leading-none text-title dark:text-white block w-[270px] sm:w-[310px] xl:w-[330px]">Product</span>
                                            <span class="text-lg font-semibold leading-none text-title dark:text-white w-[80px]">Price</span>
                                            <span class="text-lg font-semibold leading-none text-title dark:text-white w-[80px]">Qty</span>
                                        </li>
                                        <li v-for="item in order.items" :key="item.id" class="flex items-center justify-between gap-5 py-[15px] border-b border-bdr-clr dark:border-bdr-clr-drk">
                                            <div class="flex items-center gap-3 md:gap-4 lg:gap-6 ordered-product w-[270px] sm:w-[310px] xl:w-[330px]">
                                                <div class="w-16 sm:w-[90px] flex-none">
                                                    <img :src="item.image || fallbackImage" alt="product">
                                                </div>
                                                <div class="flex-1">
                                                    <span class="text-[15px] font-medium leading-none">{{ order.number }}</span>
                                                    <h5 class="font-semibold leading-none mt-2 md:mt-4">
                                                        <router-link :to="item.productUrl">{{ item.name }}</router-link>
                                                    </h5>
                                                </div>
                                            </div>

                                            <span class="text-base md:text-lg leading-none text-title dark:text-white font-semibold text-left w-[80px]">
                                                {{ formatPrice(item.price, order.currency) }}
                                            </span>
                                            <span class="text-base md:text-lg leading-none text-title dark:text-white font-semibold text-left w-[80px]">
                                                {{ formatQuantity(item.quantity) }}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <p v-if="!loading && !orders.length" class="mt-8 text-base md:text-lg">No orders yet.</p>
                            <p v-if="loading" class="mt-8 text-base md:text-lg">Loading your order history...</p>
                            <p v-if="errorMessage" class="mt-8 text-sm text-[#E13939]">{{ errorMessage }}</p>
                            <p v-if="successMessage" class="mt-8 text-sm text-[#31A051]">{{ successMessage }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <FooterOne/>
        
        <ScrollToTop/>
    </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import { useRouter } from 'vue-router';
    import NavbarOne from '@/components/navbar/navbar-one.vue';
    import ProfileTab from '@/components/profile-tab.vue';
    import FooterOne from '@/components/footer/footer-one.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
    import bg from '@/assets/img/shortcode/breadcumb.jpg'
    import { PRODUCT_PLACEHOLDER as fallbackImage } from '@/lib/placeholder'
    import Aos from 'aos';
    import { apiRequest } from '@/lib/client-api';
    import { useClientSession } from '@/composables/use-client-session';

    const session = useClientSession();
    const router = useRouter();
    const orders = ref([]);
    const loading = ref(true);
    const errorMessage = ref('');
    const successMessage = ref('');
    const reorderingOrderId = ref(null);

    function statusBadgeClass(status) {
        switch (status) {
            case 'delivered':
                return 'bg-[#31A051]';
            case 'processing':
                return 'bg-[#2563EB]';
            case 'confirmed':
                return 'bg-[#7C3AED]';
            case 'ready':
                return 'bg-[#0F766E]';
            case 'cancelled':
                return 'bg-[#E13939]';
            default:
                return 'bg-[#EC991D]';
        }
    }

    function formatOrderDate(value) {
        if (!value) {
            return 'Order date unavailable';
        }

        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }).format(new Date(value));
    }

    function formatPrice(value, currency = 'USD') {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency,
            minimumFractionDigits: 2,
        }).format(Number(value || 0));
    }

    function formatQuantity(value) {
        return Number(value || 0).toString();
    }

    function formatShippingAddress(order) {
        const parts = [
            order.shipping_address,
            order.shipping_city,
            order.shipping_country,
        ].filter(Boolean);

        return parts.length ? parts.join(', ') : 'Shipping address unavailable';
    }

    async function loadOrders() {
        loading.value = true;
        errorMessage.value = '';

        try {
            const response = await apiRequest('/orders', { token: session.token.value });
            orders.value = response.data.map((order) => ({
                ...order,
                items: (order.items || []).map((item) => ({
                    ...item,
                    productUrl: `/order-history/${order.id}`,
                })),
            }));
        } catch (error) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    async function reorder(order) {
        reorderingOrderId.value = order.id;
        errorMessage.value = '';
        successMessage.value = '';

        try {
            const response = await apiRequest(`/orders/${order.id}/reorder`, {
                method: 'POST',
                token: session.token.value,
            });

            successMessage.value = `Order ${response.data?.number || ''} has been placed successfully.`;
            await loadOrders();

            router.push({
                path: '/thank-you',
                query: {
                    order: response.data?.number || '',
                    invoice: response.data?.invoice_url || '',
                    customerMail: response.meta?.customer_mail_sent ? '1' : '0',
                    adminMail: response.meta?.admin_mail_sent ? '1' : '0',
                },
            });
        } catch (error) {
            errorMessage.value = error.message || 'Unable to reorder this order right now.';
        } finally {
            reorderingOrderId.value = null;
        }
    }

    onMounted(async ()=>{
        Aos.init()
        await session.initializeSession();
        await loadOrders();
    })
</script>
